import React from 'react';
import '../styles/sections/Footer.css';

export const Footer: React.FC = () => {
  return (
    <section className="footer">
      <div className="footerContent">
        <div>Built and designed by Oleg Glotov and Alexander Mukhin.</div>
        <div>-</div>
        <div>All rights reserved. ©</div>
      </div>
    </section>
  );
};
